import { useDispatch, useSelector } from "react-redux";
import "./../App.css"
import { removeUserAction } from "../Redux/userReducer";

const UserResult = () => {

    const dispatch = useDispatch();
    const users = useSelector(state => state.users.user);

    const removeUser = (user) => {
        dispatch(removeUserAction(user))
    }

    return (
        <div className="user">
            <div>
                <p><strong>User:</strong></p>
            </div>
            {users.length > 0 ?
                <div>
                    {users.map((user, index) =>
                        <div key={index} className="use" onClick={() => removeUser(user)}>{user.name + ','} </div>)}
                </div>
            : <div>COMMIT USER</div>}
        </div>
    )
}


export default UserResult;